import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import FMPRegionHeader from '../../components/ui/FMPRegionHeader';
import FMPSelect from '../../components/form/FMPSelect';
import FMPHeadline from '../../components/ui/FMPHeadline';
import Button from '@material-ui/core/Button';
import FileDownload from '@material-ui/icons/SaveAlt';
import BulkCustomersContainer from '../../containers/logistics/BulkCustomers';
import FMPBulkCustomerSelect from '../../components/pureForm/FMPBulkCustomerSelect';

const isLocalhost = Boolean(window.location.hostname === 'localhost');

const styles = (theme) => {
	return {
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 25,
			paddingBottom: 30,
			marginTop: 20,
			[theme.breakpoints.up('md')]: {
				padding: '10px 40px 40px 40px',
			},
		},
		bigButton: {
			borderRadius: '100px',
			padding: '18px 34px',
			fontSize: 16,
		},
		smallButton: {
			borderRadius: '100px',
			fontWeight: 300,
		},
	};
};

class Reporting extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formFieldError: {},
			when: moment().subtract(1, 'month').format('YYYY-MM'),
			exciseWhen: moment().subtract(1, 'month').format('YYYY-MM'),
			bulkTrueUpWhen: moment().subtract(1, 'month').format('YYYY-MM'),
			bulkTrueUpBulkCustomerId: '',
		};
	}

	componentDidMount() {
		//- Only used for updates
		const { bulkCustomers, searchBulkCustomers } = this.props;

		if (_.isEmpty(bulkCustomers)) {
			searchBulkCustomers();
		}
	}

	onChange = (value, path) => {
		const arrayPath = _.isString(path) ? _.toPath(path) : path;

		const val = _.isObject(value) && value.target ? value.target.value : value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};

	render() {
		const { classes, accessToken, bulkCustomers } = this.props;

		if (_.isEmpty(bulkCustomers)) {
			return <div>Fetching bulk customers..</div>;
		}

		const trueUpBulkCustomers = _.filter(bulkCustomers, 'trueUpFormula');

		//- Get the last 12 months
		const pastMonths = [];
		_.range(12).forEach((i) => {
			const m = moment().subtract(i, 'months');
			pastMonths.push({
				value: m.format('YYYY-MM'),
				display: m.format('MMMM, YYYY'),
			});
		});

		const { when, exciseWhen, bulkTrueUpWhen, bulkTrueUpBulkCustomerId } = this.state;
		const whenMoment = moment(when, 'YYYY-MM');

		//
		//- True up
		//
		const params = {
			method: 'stationInvoice.reporting.downloadGmTrueUp',
			params: {
				accessToken,
				month: whenMoment.month(),
				year: whenMoment.year(),
			},
		};

		let host = '';
		if (isLocalhost) {
			host = 'http://localhost:3700';
		}

		const downloadUrl = `${host}/api?request=${JSON.stringify(params)}`;
		const debugParams = _.clone(params);
		debugParams.params.showDebug = true;
		const debugDownloadUrl = `${host}/api?request=${JSON.stringify(debugParams)}`;

		//
		//- Excise
		//
		const exciseWhenMoment = moment(exciseWhen, 'YYYY-MM');
		const exciseParams = {
			method: 'stationInvoice.reporting.downloadCaExcise',
			params: {
				accessToken,
				month: exciseWhenMoment.month(),
				year: exciseWhenMoment.year(),
			},
		};
		const exciseDownloadUrl = `${host}/api?request=${JSON.stringify(exciseParams)}`;
		const exciseDebugParams = _.clone(exciseParams);
		exciseDebugParams.params.showDebug = true;
		const exciseDebugDownloadUrl = `${host}/api?request=${JSON.stringify(exciseDebugParams)}`;

		//
		//- Bulk True up
		//
		const bulkTrueUpWhenMoment = moment(bulkTrueUpWhen, 'YYYY-MM');
		const bulkTrueUpParams = {
			method: 'bulkInvoice.reporting.downloadBulkCustomerTrueUp',
			params: {
				accessToken,
				bulkCustomerId: bulkTrueUpBulkCustomerId,
				month: bulkTrueUpWhenMoment.month(),
				year: bulkTrueUpWhenMoment.year(),
			},
		};
		const bulkTrueUpDownloadUrl = `${host}/api?request=${JSON.stringify(bulkTrueUpParams)}`;
		const bulkTrueUpDebugParams = _.clone(bulkTrueUpParams);
		bulkTrueUpDebugParams.params.showDebug = true;
		const bulkTrueUpDebugDownloadUrl = `${host}/api?request=${JSON.stringify(
			bulkTrueUpDebugParams
		)}`;

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline label="Accounting Reports" />
					<Paper className={classes.paper}>
						<FMPRegionHeader isTop={true} label="G&M True Up Report" />

						<Grid container spacing={3}>
							<Grid item xs={12} md={4}>
								<FMPSelect label={`Month`} path={['when']} controller={this} options={pastMonths} />
							</Grid>
						</Grid>
						<Grid container spacing={3}>
							<Grid item md={8} style={{ paddingTop: 25 }}>
								<a
									href={downloadUrl}
									style={{ textDecoration: 'none', paddingRight: 5 }}
									target="_blank"
									rel="noreferrer noopener"
								>
									<Button className={classes.bigButton} variant="contained" color="primary">
										<FileDownload className={classes.downloadIcon} />
										DOWNLOAD REPORT
									</Button>
								</a>

								<a
									href={debugDownloadUrl}
									style={{ textDecoration: 'none' }}
									target="_blank"
									rel="noreferrer noopener"
								>
									<Button className={classes.smallButton} variant="outlined">
										<FileDownload className={classes.downloadIcon} />
										DOWNLOAD DEBUG VERSION
									</Button>
								</a>
							</Grid>
						</Grid>
					</Paper>

					<Paper className={classes.paper}>
						<FMPRegionHeader isTop={true} label="CA Excise Tax Refund Report" />

						<Grid container spacing={3}>
							<Grid item xs={12} md={4}>
								<FMPSelect
									label={`Month`}
									path={['exciseWhen']}
									controller={this}
									options={pastMonths}
								/>
							</Grid>
						</Grid>
						<Grid container spacing={3}>
							<Grid item md={8} style={{ paddingTop: 25 }}>
								<a
									href={exciseDownloadUrl}
									style={{ textDecoration: 'none', paddingRight: 5 }}
									target="_blank"
									rel="noreferrer noopener"
								>
									<Button className={classes.bigButton} variant="contained" color="primary">
										<FileDownload className={classes.downloadIcon} />
										DOWNLOAD REPORT
									</Button>
								</a>

								<a
									href={exciseDebugDownloadUrl}
									style={{ textDecoration: 'none' }}
									target="_blank"
									rel="noreferrer noopener"
								>
									<Button className={classes.smallButton} variant="outlined">
										<FileDownload className={classes.downloadIcon} />
										DOWNLOAD DEBUG VERSION
									</Button>
								</a>
							</Grid>
						</Grid>
					</Paper>

					<Paper className={classes.paper}>
						<FMPRegionHeader isTop={true} label="Bulk Customer True Up Report" />

						<Grid container spacing={3}>
							<Grid item xs={12} md={4}>
								<FMPSelect
									label={`Month`}
									path={['bulkTrueUpWhen']}
									controller={this}
									options={pastMonths}
								/>

								<FMPBulkCustomerSelect
									path={'bulkTrueUpBulkCustomerId'}
									label={'Bulk Customer'}
									value={this.state.bulkTrueUpBulkCustomerId}
									bulkCustomers={trueUpBulkCustomers}
									onChange={this.onChange}
								/>
							</Grid>
						</Grid>
						<Grid container spacing={3}>
							<Grid item md={8} style={{ paddingTop: 25 }}>
								<a
									href={bulkTrueUpDownloadUrl}
									style={{ textDecoration: 'none', paddingRight: 5 }}
									target="_blank"
									rel="noreferrer noopener"
								>
									<Button className={classes.bigButton} variant="contained" color="primary">
										<FileDownload className={classes.downloadIcon} />
										DOWNLOAD REPORT
									</Button>
								</a>

								<a
									href={bulkTrueUpDebugDownloadUrl}
									style={{ textDecoration: 'none' }}
									target="_blank"
									rel="noreferrer noopener"
								>
									<Button className={classes.smallButton} variant="outlined">
										<FileDownload className={classes.downloadIcon} />
										DOWNLOAD DEBUG VERSION
									</Button>
								</a>
							</Grid>
						</Grid>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

Reporting.propTypes = {
	classes: PropTypes.object.isRequired,
	bulkCustomers: PropTypes.array,
	searchBulkCustomers: PropTypes.func.isRequired,
	accessToken: PropTypes.string,
};

export default _.flow([withStyles(styles), BulkCustomersContainer])(Reporting);
